<template>
  <div class="class_notice">
    <h2 class="title_com">通知公告</h2>
    <section class="pd2430">
      <ul v-if="total !== 0">
        <li
          v-for="(item, index) in classNoticeArr"
          :key="index"
          @click="noticeDetails(item.id, index)"
          class="pointer"
        >
          <el-badge :is-dot="item.read_id == null" class="item"
            ><h2 class="fs20">{{ item.title }}</h2></el-badge
          >
          <!-- 公告内容 -->
          <div
            class="contents lh24 ellipsis_two"
            v-html="item.content"
            v-if="item.content != ''"
          ></div>
          <!-- 文档名称 -->
          <div class="contents lh24 ellipsis_two" v-else-if="item.file != ''">
            {{ item.file[0].savename }}
          </div>
          <div class="info c-999 fs14">
            <span>{{ item.create_time }}</span>
            <span>{{ item.truename }}</span>
            <span>已读人数：</span>
            <span>{{ item.read }}</span>
          </div>
        </li>
      </ul>
      <Empty v-else></Empty>
      <!-- 分页 -->
      <Pagination
        :currentPage="currentPage"
        :pageSize="pageSize"
        :total="total"
        :selectSize="[10, 20, 30, 40]"
        @changePage="changePage"
        @changeSize="changeSize"
        v-if="classNoticeArr.length !== 0"
      ></Pagination>
    </section>
  </div>
</template>

<script>
import { ClassNoticeApi } from "@/api/student";
export default {
  data() {
    return {
      currentPage: 1, //当前页数
      pageSize: 10, // 当前页条数
      total: 11, // 总数
      class_id: "", // 班级id
      classNoticeArr: [],
    };
  },
  methods: {
    // 公告详情
    noticeDetails(id, index) {
      this.$router.push({
        path: "/ClassNoticeDetail",
        query: { noticeId: id },
      });
    },
    // 当前页数改变
    changePage(page) {
      this.currentPage = page;
      this.requestCommonFn();
    },
    // 当前页数条数改变
    changeSize(size) {
      this.pageSize = size;
      this.requestCommonFn();
    },
    // 通知公告
    requestCommonFn() {
      ClassNoticeApi({
        limit: this.pageSize,
        page: this.currentPage,
        class_id: this.class_id,
      }).then((res) => {
        this.classNoticeArr = res.data.notice_list.list;
        this.classNoticeArr.map((item) => {
          if (item.file != "") {
            item.file = JSON.parse(item.file);
          }
        });
        this.total = res.data.notice_list.total;
      });
    },
    createFn() {
      let class_id = sessionStorage.getItem("class_id");
      if (class_id) {
        this.class_id = class_id;
      }
      // 通知公告
      this.requestCommonFn();
    },
  },
  created() {
      this.createFn();
  },
};
</script>
 
<style lang = "less" scoped>
.class_notice {
  background-color: #fff;
  section {
    ul {
      /deep/ li {
        background-color: #f7f7f7;
        padding: 18px 20px 18px 24px;
        margin-bottom: 20px;
        .el-badge__content.is-dot {
          left: -20px;
          top: 9px;
          width: 9px;
          height: 9px;
        }
        .contents {
          margin: 16px 0;
        }
        .info {
          span {
            margin-right: 20px;
            &:nth-child(3) {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
</style>